'use client';

import { useState } from 'react';
import { client } from '@/app/utils/client';
import { DEFAULT_LANGUAGE_ID, AUTHOR_BLOGS_PAGE_SIZE } from '@/app/utils/constants';
import { CollectionCard } from '@/components/content-types/collection-type/components/collectionCard';

export function LoadMoreBlogs({ authorId }) {
    const [blogs, setBlogs] = useState([]);
    const [nextPage, setNextPage] = useState(2);
    const [isLoading, setIsLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);

    async function loadMore() {
        setIsLoading(true);
        try {
            const result = await client.content
                .query(`+contentType:Blog +Blog.author:"${authorId}" +live:true`)
                .sortBy([{ field: 'Blog.postingDate', order: 'desc' }])
                .limit(AUTHOR_BLOGS_PAGE_SIZE)
                .page(nextPage)
                .language(DEFAULT_LANGUAGE_ID);

            const newBlogs = result?.contentlets || [];
            setBlogs((prev) => [...prev, ...newBlogs]);
            setNextPage((p) => p + 1);
            setHasMore(newBlogs.length === AUTHOR_BLOGS_PAGE_SIZE);
        } catch {
            // silently fail — user can retry by clicking again
        } finally {
            setIsLoading(false);
        }
    }

    return (
        <>
            {blogs.length > 0 && (
                <ul className="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3">
                    {blogs.map((blog, i) => (
                        <li
                            className="card-hover-pop relative shrink-0 cursor-pointer rounded-lg shadow-md"
                            key={blog.identifier || i}>
                            <CollectionCard
                                contentlet={blog}
                                contenttype="Blog"
                                showCategory={true}
                                showAuthor={false}
                                headerType="h3"
                            />
                        </li>
                    ))}
                </ul>
            )}
            {hasMore && (
                <div className="flex justify-center pt-4">
                    <button
                        onClick={loadMore}
                        disabled={isLoading}
                        className="rounded-lg border border-blue-600 px-8 py-3 text-sm font-semibold text-blue-600 transition-colors hover:bg-blue-600 hover:text-white disabled:cursor-not-allowed disabled:opacity-50">
                        {isLoading ? 'Loading…' : 'Load more articles'}
                    </button>
                </div>
            )}
        </>
    );
}
